import React, { useMemo } from "react";
import { Typography } from "@material-ui/core";
import TreeView from "@material-ui/lab/TreeView";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TreeItem from "@material-ui/lab/TreeItem";
import { makeStyles } from "@material-ui/core/styles";
import Counter from "@icarius-common/counter";
import TreeBranch from "./treeBranch";

const useStyles = makeStyles({
    labelRoot: {
        display: "flex",
        alignItems: "center",
        gap: 5,
        minHeight: 28,
    },
});

const ModulesAndMenusTree = (props) => {

    const {
        data,
        selectedIds,
        handleClick,
    } = props;

    const classes = useStyles();
    
    const ids = useMemo(() => {
        const auxIds = [];

        const getBranchIds = (branch) => {
            for (const item of branch) {
                if (item.menus?.length) getBranchIds(item.menus);
                auxIds.push(item.id);
            }
        }

        getBranchIds(data.modules);
        return auxIds;
    }, [data.modules]);

    return (
        <TreeView
            key={ids.join(", ")}
            defaultCollapseIcon={handleClick ? null : <ExpandMoreIcon />}
            defaultExpandIcon={handleClick ? null : <ChevronRightIcon />}
            defaultExpanded={handleClick ? undefined : ["root", ...ids.map((id) => `${id}`)]}
            expanded={handleClick ? ["root", ...ids.map((id) => `${id}`)] : undefined}
            style={{ width: "100%" }}

        >
            <TreeItem
                nodeId={"root"}
                label={
                    <div className={classes.labelRoot}>
                        <Typography variant="body2" style={{ paddingRight: 5 }}>
                            {data.name}
                        </Typography>
                        <Counter value={data.modules?.length} />
                    </div>
                }
            >
                {
                    data.modules?.map((module, indexModule) => {
                        return (
                            <TreeBranch
                                key={indexModule}
                                selectable={false}
                                data={module}
                                selectedIds={selectedIds}
                                handleClick={handleClick}
                            />
                        )
                    })
                }
            </TreeItem>
        </TreeView>
    );
}

export default ModulesAndMenusTree;